module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget-body",
    staticStyle: {
      "margin": "15px"
    }
  }, [_c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, [(_vm.profile.map['reports'].includes('entries')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c1"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "c1"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [(_vm.registry.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Aquisições\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_mean_price
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Vendas\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_sale_price
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('entries')
      }
    },
    model: {
      value: (_vm.date_entries_first),
      callback: function($$v) {
        _vm.date_entries_first = $$v
      },
      expression: "date_entries_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('entries')
      }
    },
    model: {
      value: (_vm.date_entries_end),
      callback: function($$v) {
        _vm.date_entries_end = $$v
      },
      expression: "date_entries_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('entries')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.acquisition_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.color))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.mean_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.sale_price))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('sales')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c2"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "c2"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [(_vm.registry.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Aquisições\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_mean_price
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Vendas\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_sale_price
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales')
      }
    },
    model: {
      value: (_vm.date_sales_first),
      callback: function($$v) {
        _vm.date_sales_first = $$v
      },
      expression: "date_sales_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales')
      }
    },
    model: {
      value: (_vm.date_sales_end),
      callback: function($$v) {
        _vm.date_sales_end = $$v
      },
      expression: "date_sales_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('sales')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.creation_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.color))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.mean_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.sale_price))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('stock')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c3"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "c3"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('stopped_entries')
      }
    },
    model: {
      value: (_vm.date_stopped_entries_first),
      callback: function($$v) {
        _vm.date_stopped_entries_first = $$v
      },
      expression: "date_stopped_entries_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('stopped_entries')
      }
    },
    model: {
      value: (_vm.date_stopped_entries_end),
      callback: function($$v) {
        _vm.date_stopped_entries_end = $$v
      },
      expression: "date_stopped_entries_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('stopped_entries')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.creation_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.color))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.mean_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.sale_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.due) + " dias")])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('pendencies')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'pendencies'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c4"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'pendencies'
    },
    attrs: {
      "id": "c4"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('pendencies')
      }
    },
    model: {
      value: (_vm.date_pendencies_first),
      callback: function($$v) {
        _vm.date_pendencies_first = $$v
      },
      expression: "date_pendencies_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('pendencies')
      }
    },
    model: {
      value: (_vm.date_pendencies_end),
      callback: function($$v) {
        _vm.date_pendencies_end = $$v
      },
      expression: "date_pendencies_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('pendencies')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.total))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/vehicle-entry/' + entry.id + '/edit'
          })
        }
      }
    }, [_vm._v("\n                            Verificar pendências\n                          ")])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('sales-by-user')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'employee-sales'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c5"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'employee-sales'
    },
    attrs: {
      "id": "c5"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('employee-sales')
      }
    },
    model: {
      value: (_vm.date_employee_sales_first),
      callback: function($$v) {
        _vm.date_employee_sales_first = $$v
      },
      expression: "date_employee_sales_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('employee-sales')
      }
    },
    model: {
      value: (_vm.date_employee_sales_end),
      callback: function($$v) {
        _vm.date_employee_sales_end = $$v
      },
      expression: "date_employee_sales_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-12"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employee_sales_user),
      expression: "employee_sales_user"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employee_sales_user = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.validateEntries('employee-sales')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.employees_sales_list), function(employee) {
    return _c('option', {
      domProps: {
        "value": employee.id_key
      }
    }, [_vm._v("\n                          " + _vm._s(employee.name) + " (" + _vm._s(employee.login) + ")\n                        ")])
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('employee-sales')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return (_vm.current === 'employee-sales') ? _c('tr', [_c('td', [_vm._v(_vm._s(entry[0].name))]), _vm._v(" "), _c('td', _vm._l((entry), function(sale) {
      return _c('div', [_vm._v("\n                        " + _vm._s(sale.fipe_vehicle) + " - PLACA: " + _vm._s(sale.plate) + " | "), _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("Total da Venda: " + _vm._s(_vm.numeral(sale.total).format('$ 0,0.00')))]), _vm._v(" "), _c('label', {
        staticClass: "label label-info"
      }, [_vm._v("\n                           Comissão: " + _vm._s(_vm.numeral(sale.commission).format('$ 0,0.00')) + "\n                        ")])])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numeral(entry[0].total_geral).format('$ 0,0.00')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numeral(entry[0].comission_geral).format('$ 0,0.00')))])]) : _vm._e()
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'expenses-vehicles'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c6"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'expenses-vehicles'
    },
    attrs: {
      "id": "c6"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }
    },
    model: {
      value: (_vm.date_vehicle_expenses_first),
      callback: function($$v) {
        _vm.date_vehicle_expenses_first = $$v
      },
      expression: "date_vehicle_expenses_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }
    },
    model: {
      value: (_vm.date_vehicle_expenses_end),
      callback: function($$v) {
        _vm.date_vehicle_expenses_end = $$v
      },
      expression: "date_vehicle_expenses_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expense_vehicle_state_selected),
      expression: "expense_vehicle_state_selected"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.expense_vehicle_state_selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                          <== Selecione ==>\n                        ")]), _vm._v(" "), _vm._l((_vm.expenses_vehicles_states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                          " + _vm._s(state.label) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expense_vehicles_vendor_selected),
      expression: "expense_vehicles_vendor_selected"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.expense_vehicles_vendor_selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                          <== Selecione um fornecedor ==>\n                        ")]), _vm._v(" "), _vm._l((_vm.expense_vehicles_vendors), function(vendor) {
    return _c('option', {
      domProps: {
        "value": vendor.id_key
      }
    }, [_vm._v("\n                          " + _vm._s(vendor.name_with_cpf) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('expenses-vehicles')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return (_vm.current === 'expenses-vehicles') ? _c('tr', {
      class: {
        'bg-success': entry.paid, 'bg-danger': !entry.paid
      }
    }, [_c('td', [_vm._v(_vm._s(entry.date))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("vehicle-entry/" + (entry.id) + "/edit")
      }
    }, [_vm._v("\n                          " + _vm._s(entry.plate) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.vendor))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(entry.amount))])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'sales-ranking-tenant'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c7"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(12)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'sales-ranking-tenant'
    },
    attrs: {
      "id": "c7"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-tenant')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_tenant_initial),
      callback: function($$v) {
        _vm.date_ranking_sales_tenant_initial = $$v
      },
      expression: "date_ranking_sales_tenant_initial"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-tenant')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_tenant_end),
      callback: function($$v) {
        _vm.date_ranking_sales_tenant_end = $$v
      },
      expression: "date_ranking_sales_tenant_end"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(tenant) {
    return (_vm.current === 'sales-ranking-tenant') ? _c('tr', [_c('td', [_vm._v(_vm._s(tenant.tenant_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tenant.tenant_fancy_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(tenant.total))])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'sales-ranking-employee'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c8"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(14)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'sales-ranking-employee'
    },
    attrs: {
      "id": "c8"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-employee')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_employee_initial),
      callback: function($$v) {
        _vm.date_ranking_sales_employee_initial = $$v
      },
      expression: "date_ranking_sales_employee_initial"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-employee')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_employee_end),
      callback: function($$v) {
        _vm.date_ranking_sales_employee_end = $$v
      },
      expression: "date_ranking_sales_employee_end"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(user) {
    return (_vm.current === 'sales-ranking-employee') ? _c('tr', [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(user.total))])]) : _vm._e()
  }), 0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-sign-in"
  }), _vm._v(" Entrada de Veículos\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data de Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_vm._v("Cor")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Valor da Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Valor de Venda")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  }), _vm._v(" Vendas\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data da Venda")]), _vm._v(" "), _c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_vm._v("Cor")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Valor da Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Valor Vendido")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-car"
  }), _vm._v(" Estoque parado\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Criado em")]), _vm._v(" "), _c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_vm._v("Cor")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Valor da Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Valor de Venda")]), _vm._v(" "), _c('th', [_vm._v("Parado há")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-warning"
  }), _vm._v(" Pendências\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Pendências")]), _vm._v(" "), _c('th', [_vm._v("Ver detalhes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-user"
  }), _vm._v(" Vendas Por Vendedor\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Vendas")]), _vm._v(" "), _c('th', [_vm._v("Total Vendido")]), _vm._v(" "), _c('th', [_vm._v("Comissão Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-money"
  }), _vm._v(" Despesas de Veículos\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data de vencimento")]), _vm._v(" "), _c('th', [_vm._v("Veículo")]), _vm._v(" "), _c('th', [_vm._v("Despesa")]), _vm._v(" "), _c('th', [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-building"
  }), _vm._v(" Ranking de Vendas por loja\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', [_vm._v("Total em Vendas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-user"
  }), _vm._v(" Ranking de Vendas por vendedor\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "75%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Total em Vendas")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b275d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report.vue
// module id = 1042
// module chunks = 1